import { safeBigNumber } from './number-util'

import type { Array } from '@blade/std-lib'
import type BigNumber from 'bignumber.js'

/**
 * https://www.mathsisfun.com/numbers/percentage-change.html
 */
export const percentageChange = (prev: number, curr: number) =>
  ((curr - prev) / prev) * 100
export const percentageChangeBn = (prev: BigNumber, curr: BigNumber) =>
  safeBigNumber(curr.minus(prev).dividedBy(prev).multipliedBy(100), 0)

/**
 * https://www.mathsisfun.com/percentage-difference.html
 */
export const relativePercentageDifference = (a: number, b: number) => {
  const sign = a < b ? -1 : 1

  const difference = a - b
  const percentageDiff = Math.abs((difference / (a + b) / 2) * 100)
  return percentageDiff * sign
}

export const toPrecision = (number: number, maxDecimals: number = 2) => {
  // Only shows decimal places if needed, unto a max number
  const factor = 10 ** maxDecimals
  return Math.round((number + Number.EPSILON) * factor) / factor
}

export const average = (items: Array.NonEmptyArray<number>): number => {
  const sum = items.reduce((acc, curr) => acc + curr, 0)
  return sum / items.length
}

export const proportion = (a: number, b: number): number => (a / (a + b)) * 100

/**
 * Adjusts a value by a given percentage
 * @param {number} value - The base value to adjust
 * @param {number} percentage - The percentage to adjust by (positive or negative)
 * @example
 * // Increase by 10%
 * adjustValueByPercentage(100, 10) // returns 110
 */
export const adjustValueByPercentage = (
  value: number,
  percentage: number,
): number => value + value * (percentage / 100)
